<style lang="scss" scoped>
	.contianer {
		width: 100%;
		height: 1190px;
		box-sizing: border-box;
		text-align: center;
	}
	.experirence-title {
		margin-top: 160px;
		margin-bottom: 50px;
	}
	.experirence-content {
		position: relative;
		width: 1311px;
		height: 602px;
		margin: 0 auto;
		background: url('../../assets/pc/experirence-content-bg.png');
		text-align: center;
		.experirence-icon1 {
			position: absolute;
			top: -37px;
    		left: -101px;
		}
		.experirence-icon2 {
			position: absolute;
			right: -38px;
			top: -20px;
		}
		.experirence-icon3 {
			position: absolute;
			bottom: 0;
    	left: -130px;
		}
		.experirence-icon4 {
			position: absolute;
			right: -104px;
    	bottom: -55px;
		}
		.experirence-icon5 {
			position: absolute;
			top: 192px;
    	right: -233px;
		}
		.more-btn {
			position: absolute;
			bottom: -5px;
			right: 0;
			cursor: pointer;
		}
	}
	.left-ct {
		position: relative;
		float: left;
		width: 756px;
		height: 460px;
		background: url('../../assets/pc/experirence-picture-bg.png');
		margin-top: 120px;
		margin-left: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 32px 24px 31px 32px;
		.image-item {
			width: 700px;
			height: 400px;
			cursor: pointer;
		}
		.banner-switch {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 25px;
			text-align: center;
			.switch-item {
				display: inline-block;
				width: 12px;
				height: 12px;
				border-radius: 20px;
				background: #bd4f67;
				cursor: pointer;
				margin: 6px 10px 0 10px;
			}
		}
	}
	.right-ct {
		float: right;
		width: 480px;
		height: auto;
		margin-top: 150px;
		margin-right: 35px;
		.switch-items {
			height: 55px;
			line-height: 55px;
			border-bottom: 1px solid #bd4f67;
			overflow: hidden;
			.switch-item {
				position: relative;
				float: left;
				text-shadow: 0 0 1px #952b4f;
				padding-left: 30px;
				padding-right: 30px;
				cursor: pointer;
				color: #952b4f;
				font-size: 28px;
				.choose-icon {
					position: absolute;
					bottom: -2px;
					left: 0;
					right: 0;
					margin: 0 auto;
				}
			}
		}
		.ct-item {
			width: 480px;
			height: 55px;
			line-height: 55px;
			border-bottom: 1px solid #bd4f67;
			margin-top: 15px;
			text-align: left;
			padding-left: 5px;
			cursor: pointer;
			font-size: 16px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			.new-icon {
				float: left;
				height: 25px;
				margin-right: 20px;
				margin-top: 15px;
			}
			span {
				color: #bd4f67;
			}
		}
	}
	.slide-fade-enter-active {
		transition: all 2s ease;
	}
	.slide-fade-enter {
		opacity: 0;
	}
</style>

<template>
  <div class="p-experirence pc-common-bg">
		<div class="contianer">
			<img class="experirence-title" src="../../assets/pc/experirence-title.png" alt="">
			<div class="experirence-content">
				<img class="experirence-icon1" src="../../assets/pc/experirence-icon1.png" alt="">
				<img class="experirence-icon2" src="../../assets/pc/experirence-icon2.png" alt="">
				<img class="experirence-icon3" src="../../assets/pc/experirence-icon3.png" alt="">
				<img class="experirence-icon4" src="../../assets/pc/experirence-icon4.png" alt="">
				<img class="experirence-icon5" src="../../assets/pc/experirence-icon5.png" alt="">
				<img @click="$router.push({name: 'p-more-experience'})" class="more-btn" src="../../assets/pc/more-btn.png" alt="">
				<!-- 轮播 -->
				<div class="left-ct">
					<!-- 图 -->
					<template v-for="(item, index) in bannerList">
						<transition name="slide-fade" :key="index" >
							<img 
								@click="goUrl(item.wsUrl)" 
								@mousemove="clearInterval" 
								@mouseout="interval" 
								v-show="bannerChooseNumber == index" 
								:src="item.wsImagePath" 
								:alt="item.wsImageName"
								class="image-item"
							>
						</transition>
					</template>
					<!-- 切换 -->
					<div class="banner-switch">
						<div v-for="(n, index) in bannerList.length" :key="n" @click="chooseBanner(index)" class="switch-item"></div>
					</div>
				</div>
				<!-- 新闻 -->
				<div class="right-ct">
					<div class="switch-items">
						<div v-for="(item, index) in switchItemList" :key="item.columnId" @click="switchItem(index, item.columnId)" class="switch-item">
							<span>{{item.columnName}}</span>
							<img v-show="itemChoose == item.columnId" class="choose-icon" src="../../assets/pc/choosing.png" alt="">
						</div>
					</div>
					<div v-for="item in itemList" :key="item.newsId" class="ct-item">
						<router-link :to="{name: 'p-news-detail', params: {newsId: item.newsId}}">
							<img v-show="item.wasNew == '1'" class="new-icon" src="../../assets/pc/news.png" alt="">
							<span>{{item.newsTitle}}</span>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<p-footer></p-footer>
	</div>
</template>

<script>
import Footer from '../../components/Footer'
export default {
	name: 'p-experirence',
	components: {
		'p-footer': Footer
	},
	data() {
		return {
			bannerList: [],
			bannerChooseNumber: 0,
			switchItemList: [],
			itemChoose: '',
			itemList: []
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width < 850) {
			this.$router.push({name: 'm-experience'});
		} else {
			this.init();
		}
	},
	methods: {
		init() {
			this.$http.get('/api/website/getWorldStoryInfo?platform=1').then((rsp) => {
				const result = rsp.result;
				this.bannerList = result.worldStory;
				this.interval();
				//
				this.switchItemList = result.columnNews;
				if(this.switchItemList.length > 0) {
					this.itemChoose = this.switchItemList[0].columnId;
					this.itemList = this.switchItemList[0].newsLists;
				}
			});
		},
		interval() {
			this.timeInterval = setInterval(() => {
				if(this.bannerList.length <= 1) {
					clearInterval(this.timeInterval);
				} else {
					if(this.bannerChooseNumber == this.bannerList.length-1) {
						this.bannerChooseNumber = 0;
					} else {
						this.bannerChooseNumber ++;
					}
				}
			}, 6000);
		},
		chooseBanner(index) {
			this.bannerChooseNumber = index;
		},
		clearInterval() {
			clearInterval(this.timeInterval);
		},
		switchItem(index, id) {
			this.itemChoose = id;
			this.itemList = this.switchItemList[index].newsLists;
		},
		goUrl(url) {
			window.open(url, '_blank');
		}
	},
	beforeDestroy() {
		this.clearInterval();
	}
}
</script>